/**  水印添加方法  */
const setWatermark = (str1: any, str2: any) => {
  const id = '1.23452384164.123412415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id) as HTMLElement)
  }
  const can = document.createElement('canvas')
  // 设置canvas画布大小
  can.width = 360
  can.height = 180
  const cans: any = can.getContext('2d')
  cans.font = '12px Microsoft YaHei'
  cans.fillStyle = 'rgba(0, 0, 0, 0.05)'
  cans.textAlign = 'center'
  cans.textBaseline = 'middle'

  const drawWatermarkGroup = (x: number, y: number) => {
    cans.save()
    cans.translate(x, y)
    cans.rotate((-20 * Math.PI) / 180) // 水印旋转角度
    cans.fillText(str1, 0, -10)
    cans.fillText(str2, 0, 12)
    cans.restore()
  }

  drawWatermarkGroup(can.width * 0.72, can.height * 0.22)
  drawWatermarkGroup(can.width * 0.22, can.height * 0.72)

  const div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.opacity = '1'
  div.style.position = 'fixed'
  div.style.zIndex = '99999'
  div.style.width = '100vw'
  div.style.height = '100vh'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}
// 添加水印方法
export const setWaterMark = (str1: any, str2: any) => {
  let id = setWatermark(str1, str2)
  if (document.getElementById(id) === null) {
    id = setWatermark(str1, str2)
  }
}
// 移除水印方法
export const removeWatermark = () => {
  const id = '1.23452384164.123412415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id) as HTMLElement)
  }
}
